import { Alert, Button, Page, Stack, Typography } from "@fideus-ui/core";
import { Logout as LogoutIcon } from "@fideus-ui/core/icons";
import { useTranslation } from "../_app/i18n";
import { translations } from "./translations";

interface RequestAccessProps {
  onRequestAccess?: () => void;
  onLogout: () => void;
  error?: string;
}

export function RequestAccess({
  onRequestAccess,
  onLogout,
  error,
}: RequestAccessProps) {
  const t = useTranslation(translations);
  return (
    <Page>
      <Typography variant="h4" gutterBottom>
        {t("requestAccessTitle")}
      </Typography>
      <Typography>{t("noAccessMessage")}</Typography>
      {error && (
        <Alert severity="error" sx={{ mt: 2 }}>
          {error}
        </Alert>
      )}
      <Stack direction="row" spacing={2} sx={{ mt: 2 }}>
        {onRequestAccess && (
          <Button variant="contained" onClick={onRequestAccess}>
            {t("requestAccessButton")}
          </Button>
        )}
        <Button
          variant="outlined"
          onClick={onLogout}
          startIcon={<LogoutIcon />}
        >
          {t("logout")}
        </Button>
      </Stack>
    </Page>
  );
}
